import './status-card.scss';
import React, { useState } from 'react';
import { format } from 'date-fns';
import { useEffect } from 'react';
import { Button } from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {useStore} from "../../hooks";

const StatusCard = ({ sectionData, rules = [], name , hideMetaData}) => {
  const rule = rules[0] || {};
  const [editingDate, setEditingDate] = useState(false);
  const store = useStore();
  const [nextReviewDate, setNextReviewDate] = useState(null);
  const handleSave = () => {
    setEditingDate(false);
     let data = {'next_reviewed': nextReviewDate?.toISOString()};

     store.api.patchEvidenceProcess(rules[0].id,data);
     store.api.patchRiskProcess(rules[0].id,data);
     store.api.patchPolicyProcess(rules[0].id,data);
     store.api.patchProcedureProcess(rules[0].id,data);


     console.log('Saved date:', nextReviewDate?.toISOString());
  };

    useEffect(() => {
    // When rules are loaded, set the date
    if (rules[0]?.next_reviewed) {
      setNextReviewDate(new Date(rules[0].next_reviewed));
    }
  }, [rules]);


  return (
    <div className="status-card">
      <div className="last-validated">
        Last validated:{' '}
        {sectionData.last_validated
          ? format(new Date(sectionData.last_validated), 'dd MM yyyy')
          : sectionData.validation_status}
      </div>

      <div className="status-indicator">
        <div className="status green-status" style={{ width: `${sectionData.percentage_passed}%` }}></div>
        <div className="status yellow-status" style={{ width: `${sectionData.percentage_underway}%` }}></div>
        <div className="status red-status" style={{ width: `${sectionData.percentage_failed}%` }}></div>
      </div>

      {!hideMetaData && (
        <span className="status-text">
          NEXT DATE:{' '}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            {editingDate ? (
                   <>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="dd/MM/yyyy"
                    value={nextReviewDate}
                    onChange={setNextReviewDate}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    InputProps={{
                      style: { fontSize: '0.875rem', width: '180px' },
                    }}
                  />
                   <Button onClick={handleSave} variant="contained" color="primary" size="small" style={{ marginLeft: 8 }}>
                      Save
                    </Button>
                    <Button onClick={() => setEditingDate(false)} size="small" style={{ marginLeft: 4 }}>
                      Cancel
                    </Button>
                   </>
            ) : (
              <span
                onClick={() => setEditingDate(true)}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                {nextReviewDate ? format(nextReviewDate, 'dd/MM/yyyy') : 'N/A'}
              </span>
            )}
          </MuiPickersUtilsProvider>
          <br />
          STATUS: {rule.review_status || 'N/A'}
          <br />
          FREQUENCY: {rule.review_frequency || 'N/A'}
        </span>
      )}
    </div>
  );
};

export default StatusCard;
